import { render, staticRenderFns } from "./TiptapVideoButton.vue?vue&type=template&id=4137597b"
import script from "./TiptapVideoButton.vue?vue&type=script&lang=ts"
export * from "./TiptapVideoButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports